import React from 'react';
import {Container, Header, Icon, Segment} from 'semantic-ui-react';
import {useTranslator} from '../../../AppInterface/lib/hooks/useTranslator.js';

export const SurveyNotFoundView = () => {
    const [t] = useTranslator('SurveyNotFoundView');

    return (
        <Container style={{'marginTop': '6rem'}}>
            <Segment placeholder padded="very">
                <Header as={'h2'} icon>
                    <Icon color={'grey'} name={'map signs'}/>
                    {t('SURVEY_NOT_FOUND')}
                </Header>
            </Segment>
        </Container>
    );
};